import { ENGINE_URL } from "@/config";
import axios from "axios";

export const engineApi = axios.create({
  baseURL: ENGINE_URL,
  withCredentials: false,
});

// Add interceptor to dynamically get token for each request
engineApi.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user-info")!); //TODO: Remove local stroage and store in context
  config.headers.Authorization = `Bearer ${user?.token}`;
  return config;
});
